import { getStore } from '@tmapy/redux';
import { history, doNotDispatch } from './history';
import { Action } from 'history';
import { registerRoutes, matchRoute } from './routes';
import { SET_ROUTE, UPDATE_HASH_PARAMS } from './constants';
import { actionSetRoute } from './actions';
const getInitialState = () => ({
    pathname: '',
    hashParams: {},
    route: null,
    params: {},
    persistedRouteParams: {},
});
const isDeepStrictEqual = (a, b) => {
    return JSON.stringify(a) === JSON.stringify(b);
};
export const router = (state, action) => {
    if (!state) {
        return getInitialState();
    }
    switch (action.type) {
        case SET_ROUTE: {
            return {
                ...state,
                ...action.payload,
                params: isDeepStrictEqual(state.params, action.payload.params)
                    ? state.params
                    : action.payload.params,
                persistedRouteParams: {
                    ...state.persistedRouteParams,
                    ...(action.payload.route ? { [action.payload.route.id]: action.payload.params } : null),
                },
            };
        }
        case UPDATE_HASH_PARAMS: {
            return {
                ...state,
                hash: action.payload.hash,
                hashParams: {
                    ...state.hashParams,
                    ...action.payload.hashParams,
                },
            };
        }
        default: {
            return state;
        }
    }
};
/**
 * Configure global locale
 */
export async function configureRouter(routeConfigs, options) {
    return new Promise((resolve) => {
        registerRoutes(routeConfigs, options);
        const updateRoute = ({ location }) => {
            if (doNotDispatch.flag) {
                doNotDispatch.flag = false;
                return;
            }
            const matchedRoutes = matchRoute(location.pathname);
            const queryParams = {};
            const searchParams = new URLSearchParams(location.search);
            for (const [key, value] of searchParams.entries()) {
                const existingValue = queryParams[key];
                if (Array.isArray(existingValue)) {
                    existingValue.push(value);
                }
                else if (existingValue !== undefined) {
                    queryParams[key] = [existingValue, value];
                }
                else {
                    queryParams[key] = value;
                }
            }
            const params = {
                ...queryParams,
                ...matchedRoutes[0]?.params,
            };
            getStore().dispatch(actionSetRoute(location, matchedRoutes[0] ?? null, params));
        };
        setTimeout(() => {
            updateRoute({ action: Action.Replace, location: history.location });
            resolve();
        }, 0);
        history.listen(updateRoute);
    });
}
//# sourceMappingURL=redux.js.map